import FieldPermissionShow from './FieldPermissionShow'
export {FieldPermissionShow}
export default FieldPermissionShow
